import React, { Component } from 'react';
import { connect } from 'react-redux';

const TagBadge = props => {
  const {tag, ...rest} = props;
  const onTouchTap = e => {
    e.preventDefault();
    e.stopPropagation();
    if (props.onSelectTag) {
      props.onSelectTag(tag);
    }
  };
  return <span onTouchTap={onTouchTap} {...rest}>{tag}</span>;
};

export default connect(
  state => ({}),
  dispatch => ({
    onSelectTag(data) {
      // TODO: logic placeholder for selecting a tag
    }
  })
)(TagBadge);
